/**
 * pl-cart-minimum-order.js (v4)
 * ------------------------------------------------------------
 * v1 substituia o `.cart-checkout` inteiro, o que pisava em partes
 * que ja sao atualizadas de forma reativa por outro script do tema
 * (ex: valor do PIX, preenchido via JS apos o load - a troca total
 * apagava esse valor calculado e nada o repunha).
 *
 * v2 substitui SOMENTE os dois pedacos que realmente dependem do
 * calculo em Liquid do valor minimo do pedido:
 *   1) [data-cart-minimum-order-wrapper] - o aviso amarelo
 *   2) [data-cart-checkout-actions]      - o botao de checkout
 *      (habilitado/desabilitado)
 *
 * v3 nao chegou a ser aplicada aqui (o valor do pix foi corrigido
 * direto no override updatePixDiscount do bundle, em outro arquivo).
 *
 * v4 adiciona um terceiro alvo: [data-cart-cashback-wrapper], o aviso
 * de "faltam X para o cashback". Usa exatamente a mesma tecnica dos
 * outros dois (Section Rendering API + swap de innerHTML), sem
 * nenhum mecanismo novo. Nao afeta e nao depende do calculo do
 * minimo do pedido (pl_mo_locked) - sao dois avisos independentes
 * que soh dividem a mesma base de calculo (cart.items_subtotal_price)
 * no Liquid.
 *
 * Tudo o mais dentro de `.cart-checkout` (subtotal, frete, pix)
 * continua sendo gerenciado pelo proprio bundle do tema, sem
 * interferencia.
 * ------------------------------------------------------------
 */
(function () {
  'use strict';

  if (window.__plCartMinimumOrderInit) return;
  window.__plCartMinimumOrderInit = true;

  var CART_ENDPOINTS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
  var isRefreshing = false;
  var pendingRefresh = false;

  function isCartMutationUrl(url) {
    if (!url) return false;
    var path = String(url).split('?')[0];
    for (var i = 0; i < CART_ENDPOINTS.length; i++) {
      if (path.indexOf(CART_ENDPOINTS[i]) !== -1) return true;
    }
    return false;
  }

  // Sem debounce artificial: a primeira mudança de carrinho dispara a
  // atualização imediatamente. Se novas mudanças chegarem enquanto uma
  // busca já está em andamento (single-flight), elas são agrupadas em
  // uma única atualização extra ao final — nunca uma requisição por clique.
  function scheduleRefresh() {
    if (isRefreshing) {
      pendingRefresh = true;
      return;
    }
    refreshCartMinimumOrder();
  }

  function swapIfChanged(currentEl, freshEl) {
    if (!currentEl || !freshEl) return;
    if (currentEl.innerHTML === freshEl.innerHTML) return;
    requestAnimationFrame(function () {
      currentEl.innerHTML = freshEl.innerHTML;
    });
  }

  function refreshCartMinimumOrder() {
    var wrapperEl = document.querySelector('[data-cart-minimum-order-wrapper]');
    var actionsEl = document.querySelector('[data-cart-checkout-actions]');
    var cashbackEl = document.querySelector('[data-cart-cashback-wrapper]');

    if (!wrapperEl && !actionsEl && !cashbackEl) return;

    var anchorEl = wrapperEl || actionsEl || cashbackEl;
    var sectionWrapper = anchorEl.closest('[id^="shopify-section-"]');
    if (!sectionWrapper) return;

    var sectionId = sectionWrapper.id.replace('shopify-section-', '');

    isRefreshing = true;

    fetch('/?sections=' + encodeURIComponent(sectionId), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Falha ao buscar section: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var freshWrapper = doc.querySelector('[data-cart-minimum-order-wrapper]');
        var freshActions = doc.querySelector('[data-cart-checkout-actions]');
        var freshCashback = doc.querySelector('[data-cart-cashback-wrapper]');

        swapIfChanged(wrapperEl, freshWrapper);
        swapIfChanged(actionsEl, freshActions);
        swapIfChanged(cashbackEl, freshCashback);
      })
      .catch(function (err) {
        console.warn('[pl-cart-minimum-order] Nao foi possivel atualizar o carrinho:', err);
      })
      .finally(function () {
        isRefreshing = false;
        if (pendingRefresh) {
          pendingRefresh = false;
          scheduleRefresh();
        }
      });
  }

  var originalFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] instanceof Request ? arguments[0].url : arguments[0];
    var isCartCall = isCartMutationUrl(url);

    return originalFetch.apply(this, arguments).then(function (response) {
      if (isCartCall) scheduleRefresh();
      return response;
    });
  };

  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__plIsCartCall = isCartMutationUrl(url);
    return originalOpen.apply(this, arguments);
  };

  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__plIsCartCall) {
      this.addEventListener('loadend', function () {
        scheduleRefresh();
      });
    }
    return originalSend.apply(this, arguments);
  };

  function observeCartCount() {
    var cartCountEl = document.querySelector('[data-cart-count], .cart-count, #cart-icon-bubble');
    if (!cartCountEl) return;

    var observer = new MutationObserver(function () {
      scheduleRefresh();
    });

    observer.observe(cartCountEl, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCartCount);
  } else {
    observeCartCount();
  }
})();